import { render, staticRenderFns } from "./Purcharse.vue?vue&type=template&id=395b5e65&scoped=true&"
import script from "./Purcharse.vue?vue&type=script&lang=js&"
export * from "./Purcharse.vue?vue&type=script&lang=js&"
import style0 from "./Purcharse.vue?vue&type=style&index=0&id=395b5e65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b5e65",
  null
  
)

export default component.exports